module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/bme_on-5e3e2cd1dc70c2a08791ed4079aaa128.gif";